export interface IInstitucion {
  claveInstitucion?: string | null;
  nombreInstitucion?: string | null;
}

export class Institucion implements IInstitucion {
  constructor(public claveInstitucion?: string | null, public nombreInstitucion?: string | null) {}

  static fromObject(data: IInstitucion): Institucion {
    const institucion = new Institucion();
    for (const [key, value] of Object.entries(data)) {
      institucion[key] = value;
    }
    return institucion;
  }
}
